export const REMAINING_SPOTS_THRESHOLD = 10;
